import { User } from "@/v2/types";

function checkCondition(
    user: User | null,
    requestedPermission: {
        module: string;
        value: string;
        field: string;
        operator: string;
    },
) {
    if (!user) {
        return false;
    }

    if (user.is_admin || user?.roles?.some((role: any) => role.is_admin)) {
        return true;
    }

    if (user?.roles) {
        for (const role of user.roles) {
            if (role?.module_permissions) {
                for (const permission of role.module_permissions) {
                    if (requestedPermission.module !== permission.module.handle)
                        continue;

                    if (permission.full_access_to_module) return true;

                    if (
                        permission.condition.value ===
                            requestedPermission.value &&
                        permission.condition.field ===
                            requestedPermission.field &&
                        permission.condition.operator ===
                            requestedPermission.operator
                    ) {
                        return true;
                    }
                }
            }
        }
    }

    return false;
}

export default checkCondition;
